const getValuesAndLabels = (
  propValueObject: Record<string, any>,
  key: string
) =>
  Object.keys(propValueObject || {}).map((valueOption) => ({
    value: valueOption,
    label: `apartment.${key}.${valueOption}`
  }))

// clientForm
const languages = [
  {
    value: 'fi',
    label: 'language.fi'
  },
  {
    value: 'en',
    label: 'language.en'
  }
]

// information form
const checkboxProperties = [
  {
    value: 'renovatedCheckBoxProperty',
    label: 'apartment.additionalProperties.renovatedCheckBoxProperty'
  },
  {
    value: 'hasElevator',
    label: 'apartment.additionalProperties.elevator'
  },
  {
    value: 'internetIncluded',
    label: 'apartment.additionalProperties.internetIncluded'
  },
  {
    value: 'hasSaunaCheckBoxProperty',
    label: 'apartment.additionalProperties.hasSaunaCheckBoxProperty'
  },
  {
    value: 'isFurnished',
    label: 'apartment.additionalProperties.furnished'
  },
  {
    value: 'hasBuiltInClosetCheckBoxProperty',
    label: 'apartment.additionalProperties.hasBuiltInClosetCheckBoxProperty'
  },
  {
    value: 'petsAllowedCheckBoxProperty',
    label: 'apartment.additionalProperties.petsAllowedCheckBoxProperty'
  },
  {
    value: 'firstRentDiscount50PercentCheckBoxProperty',
    label: 'apartment.additionalProperties.firstRentDiscount50PercentCheckBoxProperty'
  }
]

export { getValuesAndLabels, checkboxProperties, languages }
